import React from 'react';
import { connect } from 'react-redux'

const rupiah = (number)=>{
    var res = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR"
    }).format(number);
    
    return res;
  }

const Price = (props) => {
    return (
        <>
            {
                rupiah(props.children).replace(",00", "")
            }
        </>
    )
}

const mapStateToProps = state => ({
    currency: state.total.currency
});

export default connect(mapStateToProps, {})(Price);